import React from "react";
import { safeJSONParse } from "../../../utils/helper";
import styles from "../agent-response.module.scss";

type LocalizerAgentProps = {
  parsedContent: any;
  handleSuggestionClick: (suggestion: string) => void;
};

export default function LocalizerAgent({
  parsedContent,
  handleSuggestionClick,
}: LocalizerAgentProps): JSX.Element {
  const finalAnswer = safeJSONParse(parsedContent?.finalAnswer);
  const question = parsedContent?.question;
  return (
    <>
      <div className="rtl-text">
        <div className={styles.postHeader}>
          <h3>{finalAnswer?.payload?.headline_ar}</h3>
          <h4>{finalAnswer?.payload?.subheadline_ar}</h4>
          <p>{finalAnswer?.payload?.date}</p>
        </div>

        <div className={styles.pressReleaseContent}>
          {(finalAnswer?.payload?.body_ar || []).map(
            (body: string, idx: number) => (
              <p key={idx}>{body}</p>
            )
          )}
          {(finalAnswer?.payload?.clarification_flags || []).map(
            (body: string, idx: number) => (
              <p key={idx}>{body}</p>
            )
          )}
          {(finalAnswer?.payload?.localization_notes || []).map(
            (body: string, idx: number) => (
              <p key={idx}>{body}</p>
            )
          )}
        </div>

        <div className={styles.mediacontact}>
          {finalAnswer?.payload?.media_contact}
        </div>
      </div>
      {finalAnswer?.payload?.suggestions &&
        finalAnswer?.payload?.suggestions?.length > 0 && (
          <div className={styles.suggestionsContainer}>
            {finalAnswer?.payload?.suggestions?.map(
              (suggestion: string, idx: number) => (
                <div
                  className={styles.suggestionBox}
                  key={idx}
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  <p>{suggestion}</p>
                </div>
              )
            )}
          </div>
        )}
      <div className={styles.finalQuestion}>{question}</div>
    </>
  );
}
